export default "__VITE_ASSET__bab960fd__"